import axios, { AxiosRequestConfig } from "axios";

// Backend API base URL
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

axios.defaults.baseURL = API_URL;

// Request interceptor - Token add karo automatically
axios.interceptors.request.use(
    (config) => {
        // Resident token (frontend)
        const residentToken = localStorage.getItem("residentToken");
        // Admin token (if admin)
        const adminToken = localStorage.getItem("token");
        
        const token = residentToken || adminToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor - 401 handle karo
axios.interceptors.response.use(
    (response) => response.data,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("residentToken");
            localStorage.removeItem("residentData");
            window.location.href = "/resident/login";
        }
        return Promise.reject(error);
    }
);

class APIClient {
    get = (url: string, params?: any) => axios.get(url, { params });
    create = (url: string, data: any) => axios.post(url, data);
    update = (url: string, data: any) => axios.put(url, data);
    put = (url: string, data: any) => axios.put(url, data);
    post = (url: string, data: any) => axios.post(url, data);
    delete = (url: string, config?: AxiosRequestConfig) => axios.delete(url, config);
}

export { APIClient };